export const TRANSLATION_START = '<p><strong>--- Vertaald hieronder voor uw gemak / Translated below for your convenience ---</strong></p>';
export const TRANSLATION_END = '<p><strong>--- Einde vertaling / End of translation ---</strong></p>';
export const QUOTED_REPLY_MARKER = '<p><strong>--- Vorig mailbericht / Previous mail conversation ---</strong></p>';

const LANGUAGE_LABELS: Record<string, string> = {
  fr: 'Frans / French',
  en: 'Engels / English',
  tr: 'Turks / Turkish',
  uk: 'Oekraïens / Ukrainian',
  ary: 'Arabisch / Arabic',
  pl: 'Pools / Polish',
  es: 'Spaans / Spanish',
  de: 'Duits / German',
  ro: 'Roemeens / Romanian',
  ru: 'Russisch / Russian',
};

export function buildTranslationBlock(translations: Record<string, string>): string {
  const parts: string[] = [TRANSLATION_START];

  for (const [lang, content] of Object.entries(translations)) {
    const label = LANGUAGE_LABELS[lang] || lang.toUpperCase();
    parts.push('<hr>');
    parts.push(`<p><strong>[${label}]</strong></p>`);
    parts.push(content);
  }

  parts.push(TRANSLATION_END);
  return parts.join('');
}

/**
 * Splits HTML into the new message content and the quoted reply section.
 * Returns [newContent, quotedReply] where quotedReply includes the marker.
 */
export function splitAtQuotedReply(html: string): [string, string] {
  const markerIndex = html.indexOf(QUOTED_REPLY_MARKER);
  if (markerIndex === -1) return [html, ''];
  return [html.substring(0, markerIndex), html.substring(markerIndex)];
}

export function stripTranslationBlock(html: string): string {
  const startIndex = html.indexOf(TRANSLATION_START);
  if (startIndex === -1) return html;

  const endIndex = html.indexOf(TRANSLATION_END);
  if (endIndex === -1) return html;

  const before = html.substring(0, startIndex);
  const after = html.substring(endIndex + TRANSLATION_END.length);

  return before + after;
}

/**
 * Extracts only the new message content (no translation block, no quoted reply)
 * to send for translation.
 */
export function extractTranslatableContent(html: string): string {
  const stripped = stripTranslationBlock(html);
  const [newContent] = splitAtQuotedReply(stripped);
  return newContent;
}

/**
 * Assembles the final HTML: new content + translation block + quoted reply.
 */
export function assembleWithTranslation(html: string, translations: Record<string, string>): string {
  const stripped = stripTranslationBlock(html);
  const [newContent, quotedReply] = splitAtQuotedReply(stripped);
  const block = buildTranslationBlock(translations);
  return newContent + block + quotedReply;
}
